/**
 * Rozhraní definující poskytovatele přihlašovacích údajů.
 * @includeToDoc
 */
export interface ILoginCredentialsProvider {

    /**
     * Vrací uživatelské jméno
     * @param withDefaultDomain Zda má obsahovat i doménu nastavenou v initParams
     */
    getUsername(withDefaultDomain?: boolean): string;

    /**
     * Vrací heslo uživatele.
     */
    getPassword(): string;

    /**
     * Vrací jazyk, pod kterým se uživatel přihlašuje.
     */
    getLanguage(): string;
}
